import { render, staticRenderFns } from "./DashboardEvolucao.vue?vue&type=template&id=1f15e12a"
import script from "./DashboardEvolucao.vue?vue&type=script&lang=js"
export * from "./DashboardEvolucao.vue?vue&type=script&lang=js"
import style0 from "./DashboardEvolucao.vue?vue&type=style&index=0&id=1f15e12a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports